import React, { useState, useEffect, createContext, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import './App.css';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import RequestQuote from './pages/RequestQuote';
import Contact from './pages/Contact';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import ChillerSelector from './pages/ChillerSelector';

// Layout
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import StickyRFQ from './components/layout/StickyRFQ';

// Context
export const AuthContext = createContext();

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function useApi() {
  const { token } = useContext(AuthContext);
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
  return { API_URL, headers, token };
}

function AppContent() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="min-h-screen flex flex-col bg-[var(--surface-0)]">
      {!isAdmin && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:category" element={<Products />} />
          <Route path="/products/detail/:slug" element={<ProductDetail />} />
          <Route path="/request-quote" element={<RequestQuote />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/chiller-selector" element={<ChillerSelector />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyRFQ />}
    </div>
    );
}

function App() {
  const [token, setToken] = useState(() => localStorage.getItem('admin_token') || null);
  const login = (t) => { setToken(t); localStorage.setItem('admin_token', t); };
  const logout = () => { setToken(null); localStorage.removeItem('admin_token'); };

  return (
    <AuthContext.Provider value={{ token, login, logout }}>
      <Router>
        <AppContent />
        <Toaster position="top-right" />
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
